import { Injectable }  from '@angular/core';
import { Response } from '@angular/http';

@Injectable()
export class ErrorHandlerService {

	public getErrorMessage(error: Response, defaultMessage: string): string {
		if ((error.status === 400 || error.status === 500) && error.json().messageDe) {
			return error.json().messageDe
		}
		return defaultMessage
	}
}



// WEBPACK FOOTER //
// ./src/app/services/error-handler.service.ts